import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "mx-2" }
const _hoisted_4 = { class: "mx-2" }
const _hoisted_5 = { class: "mx-2" }

import { computed, onMounted, ref, watch } from "vue";
import { getEloUsuario } from "@/services/EloService";
import ProgressCircular from "../Commons/ProgressCircular.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SparklineElo',
  props: {
    idUsuario: {}
  },
  setup(__props: any) {

const props = __props;

const isLoading = ref(true);

const gradients = ref<string[][]>([
  ["#222"],
  ["#42b3f4"],
  ["red", "orange", "yellow"],
  ["purple", "violet"],
  ["#00c6ff", "#F0F", "#FF0"],
  ["#f72047", "#ffd200", "#1feaea"],
]);

const value = ref<number[]>([]);
const width = ref<number>(2);
const radius = ref<number>(10);
// Con margen: las etiquetas de los extremos no se cortan
const padding = ref<number>(16);
const lineCap = ref<string>("round");
const gradient = ref<string[]>(gradients.value[5]);
const gradientDirection = ref<string>("top");
const fill = ref<boolean>(false);
const type = ref<string>("trend");
const autoLineWidth = ref<boolean>(false);

const mejorResultado = ref<number>();
const peorResultado = ref<number>();
const resultadoActual = ref<number>();

// Las etiquetas que se enseñan: el actual, el mejor, el peor y el primero, por ese orden, y ninguna demasiado cerca
// de otra ya puesta
const indicesConEtiqueta = computed(() => {
  const elos = value.value;
  const elegidos = new Set<number>();
  if (elos.length === 0) return elegidos;
  const separacion = Math.max(1, Math.floor(elos.length / 8));
  const candidatos = [
    elos.length - 1,
    elos.indexOf(Math.max(...elos)),
    elos.indexOf(Math.min(...elos)),
    0,
  ];
  for (const indice of candidatos)
    if ([...elegidos].every(otro => Math.abs(otro - indice) >= separacion))
      elegidos.add(indice);
  return elegidos;
});

async function cargar() {
  if (props.idUsuario != undefined) {
    try {
      isLoading.value = true;
      const response = await getEloUsuario(props.idUsuario);
      if (response.status != 200) return;
      const elos = response.data.elos.map(
        (elo: { puntuacionElo: unknown }) => elo.puntuacionElo
      );

      value.value = elos;

      mejorResultado.value = Math.max(...elos);
      peorResultado.value = Math.min(...elos);
      resultadoActual.value = await elos[elos.length - 1];
    } catch (error) {
      isLoading.value = false;
      console.error("Error al obtener datos del usuario:", error);
    } finally {
      isLoading.value = false;
    }
  } else {
    isLoading.value = false;
  }
}

onMounted(cargar);
// En la ficha de jugador la vista se reutiliza al pasar de uno a otro
watch(
  () => props.idUsuario,
  (nuevo, anterior) => {
    if (nuevo !== anterior) cargar();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_sparkline = _resolveComponent("v-sparkline")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ProgressCircular)
      ]))
    : (value.value.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_card, { class: "mb-2 mt-0 px-4 text-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_sparkline, {
                        "auto-line-width": autoLineWidth.value,
                        fill: fill.value,
                        gradient: gradient.value,
                        "gradient-direction": gradientDirection.value,
                        "line-width": width.value,
                        "model-value": value.value,
                        padding: padding.value,
                        smooth: radius.value || false,
                        "stroke-linecap": lineCap.value,
                        type: type.value,
                        "label-size": 11,
                        "auto-draw": ""
                      }, {
                        label: _withCtx((item) => [
                          _createTextVNode(_toDisplayString(indicesConEtiqueta.value.has(item.index) ? item.value : ""), 1)
                        ]),
                        _: 1
                      }, 8, ["auto-line-width", "fill", "gradient", "gradient-direction", "line-width", "model-value", "padding", "smooth", "stroke-linecap", "type"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, { class: "d-flex justify-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, "Mejor: " + _toDisplayString(mejorResultado.value), 1),
                  _createElementVNode("span", _hoisted_4, "Peor: " + _toDisplayString(peorResultado.value), 1),
                  _createElementVNode("span", _hoisted_5, "Actual: " + _toDisplayString(resultadoActual.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
}
}

})